/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigCreateEvent
 */
export interface ConfigCreateEvent {
    /**
     * Conditions to enable create events.
     * @type {string}
     * @memberof ConfigCreateEvent
     */
    enabled: ConfigCreateEventEnabledEnum;
}


/**
 * @export
 */
export const ConfigCreateEventEnabledEnum = {
    Always: 'always',
    Never: 'never'
} as const;
export type ConfigCreateEventEnabledEnum = typeof ConfigCreateEventEnabledEnum[keyof typeof ConfigCreateEventEnabledEnum];


/**
 * Check if a given object implements the ConfigCreateEvent interface.
 */
export function instanceOfConfigCreateEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function ConfigCreateEventFromJSON(json: any): ConfigCreateEvent {
    return ConfigCreateEventFromJSONTyped(json, false);
}

export function ConfigCreateEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigCreateEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function ConfigCreateEventToJSON(value?: ConfigCreateEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

